import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxI18nService } from '@studiohyperdrive/ngx-i18n';

import { CypressTagDirective } from '@cjm/cypress/core';
import { ButtonClasses, ImageComponent, LayoutContainerComponent, LinkComponent } from '@cjm/shared/ui/common';

import { I18nKeys } from '../../../i18n';

@Component({
	selector: 'vloket-we-grow-together-section',
	templateUrl: 'we-grow-together-section.component.html',
	styleUrls: ['we-grow-together-section.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [LayoutContainerComponent, LinkComponent, ImageComponent, TranslateModule, CypressTagDirective]
})
export class WeGrowTogetherSectionComponent {
	@HostBinding('class.c-we-grow-together-section') private readonly hasPageClass: boolean = true;

	public readonly assetUrl: string = 'img/home/groei-doen-we-samen.svg';
	public readonly buttonClasses: typeof ButtonClasses = ButtonClasses;
	public readonly i18nKeys: typeof I18nKeys = I18nKeys;

	constructor(public i18nService: NgxI18nService) {}
}
